module.exports = __webpack_public_path__ + "img/Sycamore V2 960x540.bbbe348b.png";